import React from "react";

const HRDVCoverageAreas = ({ title, paragraphs, image, imageAlt }) => {
  return (
    <section className="hrdv-coverage-section">
      <div className="container">
        <div className="row align-items-center g-5">
          <div
            className="col-md-7"
            data-aos="fade-right"
            data-aos-duration="1200"
            data-aos-once="true"
          >
            <h2>{title}</h2>
            <div className="hrdv-coverage-content">
              {paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </div>

          <div
            className="col-md-5 hrdv-coverage-img-col"
            data-aos="fade-left"
            data-aos-duration="1200"
            data-aos-once="true"
          >
            <img
              src={image}
              alt={imageAlt}
              className="hrdv-coverage-img"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HRDVCoverageAreas;
